<template>
  <alert-page emoji="👋‍"
              title="שמחים שחזרת! מספר הטלפון שלך קיים אצלנו במערכת"
              :show-button="true"
              button-title="קחו אותי לתזרים"
              :button-action="goToCashflow"
              :show-support-footer="true">
    <template #content>
      <div class="explain">כנראה שנרשמת כבר לשירות עם המספר הזה.</div>
    </template>
  </alert-page>
</template>

<script>
import Segment from '@/Segment';
import router from '@/router';
import AlertPage from '@/base-components/AlertPage';

export default {
  name: 'SignupMemberAlreadyExistsError',
  components: {
    AlertPage,
  },
  async created() {
    Segment.trackUserGot('SignupMemberAlreadyExistsError', { phoneNumber: this.phoneNumber });
  },
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  methods: {
    goToCashflow() {
      router.push('/sr');
    },
  },
};
</script>
